import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Button, Grid2 } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { CreateS12ThresholdsAction  } from '../actions/DataManagementActions';
import { enqueueSnackbar } from 'actions';

const S12ThresholdsHistoryUpdateForm = () => {
	const userId = useSelector(state => state.session.user.id);
	const dispatch = useDispatch();
	const [fileName, setFileName] = useState('');
	const [selectedFile, setSelectedFile] = useState(null);

	const handleFileChange = (e) => {
		setSelectedFile(e.target.files[0]);
		setFileName(e.target.files[0].name);
	};

	const handleSubmit = async () => {
		if (!selectedFile) {
			dispatch(enqueueSnackbar({ message: 'Please select a file.', options: { variant: 'error' } }));
			return;
		}

		const formData = new FormData();
		formData.append('File', selectedFile);
		formData.append('UserId', userId);

		try {
			const data = await CreateS12ThresholdsAction(formData); // Chama a action para excluir
			dispatch(enqueueSnackbar({ message: data.message, options: { variant: 'success' } }));

			setSelectedFile(''); // Limpa a seleção
			setFileName(''); // Limpa a seleção
		} catch (error) {
			dispatch(enqueueSnackbar({ message: `${error}`, options: { variant: 'error' } }));
		}
	};

	return (
		<Grid2 container spacing={2}>
			<Grid2 item size={12}>
				<TextField
					label="File Name"
					variant="outlined"
					fullWidth
					InputProps={{
						readOnly: true,
						disabled: true
					  }}
					value={fileName}				
				/>
			</Grid2>
			<Grid2 item size={12}>
				<Button
					variant="contained"
					component="label"
					fullWidth
					startIcon={<UploadFileIcon />}
				>
					Upload File
					<input type="file" hidden onChange={handleFileChange} />
				</Button>
			</Grid2>
			<Grid2 item size={12}>
				<Button variant="contained" color="primary" fullWidth onClick={handleSubmit}>
					Submit
				</Button>
			</Grid2>
		</Grid2>
	);
};

export default S12ThresholdsHistoryUpdateForm;